import { Tabs } from '@studiometa/ui';
import { transition } from '@studiometa/js-toolkit/utils';

/**
 *  Quick Access component
 */
export default class Toggle extends Tabs {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Toggle',
    refs: [...Tabs.config.refs, 'toggle', 'toggleInner'],
    options: {
      styles: {
        type: Object,
        merge: true,
        default: () => ({
          btn: {
            open: '',
            closed: '',
          },
          content: {
            open: 'opacity-100 visible pointer-event-auto delay-100',
            closed: 'absolute opacity-0 pointer-events-none invisible',
          },
        }),
      },
    },
  };

  /**
   * CurrentIndex
   * @type {number}
   */
  currentIndex = 0;

  /**
   * Switch tab on button click.
   * @this {TabsInterface}
   * @param  {Event}  event The click event object.
   * @param  {number} index The index of the clicked button.
   * @returns {void}
   */
  onBtnClick(event, index) {
    super.onBtnClick(event, index);
    this.currentIndex = index;
    this.updateIndicator();
  }

  /**
   * Switch tab on Toggle click
   * @this {TabsInterface}
   * @param  {Event}  event The click event object.
   * @returns {void}
   */
  onToggleClick(event) {
    this.onBtnClick(event, this.currentIndex === 0 ? 1 : 0);
  }

  /**
   * Update indicator position.
   */
  updateIndicator() {
    transition(
      this.$refs.toggleInner,
      {
        to: {
          transform: `translate(${this.currentIndex * 22}px, -50%)`,
        },
      },
      'keep',
    );
  }
}
